<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <quick-info-query></quick-info-query>
        </v-flex>
        <v-flex xl6 xs12>
          <general></general>
        </v-flex>
        <v-flex xl6 xs12>
          <premium></premium>
        </v-flex>
        <v-flex xl6 xs12>
          <shipment></shipment>
        </v-flex>
        <v-flex xl6 xs12>
          <insured></insured>
        </v-flex>
        <v-flex xs12>
          <clause></clause>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <comments query></comments>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import { quoteStatus } from '@/const/underwriting'
import QuickInfoQuery from './QuickInfoQuery'
import General from './General'
import Premium from './Premium'
import Shipment from './Shipment'
import Insured from './Insured'
import Clause from './Clause'
import Comments from '../../shared/Comments'

export default {
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    currentStatus() {
      return quoteStatus[this.$store.state.agency.quotation.commonInfo.statusCode]
    }
  },
  methods: {
    async doInit() {
      try {
        const dispatchObj = {
          proposalNo: this.id,
          query: true
        }
        await this.$store.dispatch('loadQuote', dispatchObj)
      } catch (err) {
        throw err
      }
    }
  },
  props: [
    'id'
  ],
  components: {
    QuickInfoQuery,
    General,
    Premium,
    Shipment,
    Insured,
    Clause,
    Comments
  }
}
</script>

<style>

</style>
